import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Box } from '@mui/material';

import { Radio, RadioProps } from '@occc-app/design-system';

interface IProps {
  label: string | React.ReactNode;
}

export const FormRadio: React.FC<IProps & RadioProps> = ({ label, ...props }) => {
  return (
    <Box>
      <FormControlLabel control={<Radio color='primary' {...props} />} label={label} />
    </Box>
  );
};
